import "./libraryPodcast.scss";

import Button from "../../atoms/button/button";
import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";

const LibraryPodcast = (props: ReferenciaContenido) => {
  const libraryPodcastData = props;
  const descriptionRaw = libraryPodcastData?.descripcion?.raw;
  const parsedDescription = descriptionRaw ? JSON.parse(descriptionRaw) : null;
  const descriptionValue = parsedDescription?.content[0]?.content[0]?.value;
  return (
    <div className="m-podlibrary">
      <div className="m-podlibrary__content">
        <div className="m-podlibrary__content__col1">
          <h2 className="m-podlibrary__title">
            {libraryPodcastData?.tituloGeneral}
          </h2>

          <p>{descriptionValue}</p>
          <div className="m-podlibrary__content__col1__btn">
            <Button
              text={props.tituloBoton}
              classname={"a-button secondary l-large"}
              type={"link"}
              isDisabled={false}
              strictCss={false}
              gtmMark={"gtmRedDeAmorNosEscuchamosVerMas"}
              href={props.redireccionBoton}
            />
          </div>
        </div>
        <div className="m-podlibrary__content__col2">
          <iframe
            className="a-spotifybox-container-link"
            src={
              libraryPodcastData?.referenciaPlantillaContenido[0]
                ?.redireccionBoton
            }
            allow="encrypted-media"
          ></iframe>
          <iframe
            className="a-spotifybox-container-link"
            src={
              libraryPodcastData?.referenciaPlantillaContenido[1]
                ?.redireccionBoton
            }
            allow="encrypted-media"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default LibraryPodcast;
